module.exports = __webpack_public_path__ + "static/media/toyota_logo.8f0e891e.png";